import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";
import Translator from "../../Translation/Translator";

export default function* bankAccountDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_DELETE_REQUEST
    });

    const res = yield call(Http.delete, `bankAccount/${action.payload?.bankAccount.id}`);

    const bankAccount: BankAccountInterface = action.payload?.bankAccount.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_DELETE_SUCCESS,
      payload: {
        bankAccount: bankAccount
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-bank-account-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchBankAccountDelete() {
  yield takeEvery(Constants.GLOBAL_BANK_ACCOUNT_DELETE_START, bankAccountDelete);
}
